import { jsx as t, jsxs as $, Fragment as z } from "react/jsx-runtime";
import { useButton as A } from "@react-aria/button";
import v from "classnames";
import { forwardRef as I, useRef as T, useImperativeHandle as _ } from "react";
import { Link as j } from "react-router-dom";
import { V as E } from "./VisuallyHidden-42oizZZl.js";
import { I as H } from "./Icon-BcAne5bE.js";
const B = "ds-btn__label", P = j, R = I(
  ({
    variant: m = "primary",
    label: n,
    icons: r,
    size: u = "medium",
    className: o,
    asLink: s,
    asRouterLink: c,
    colors: e,
    hideLabel: d = !1,
    tightenContent: i,
    onPress: N,
    onClick: x,
    style: l,
    ...a
  }, g) => {
    const b = T(null);
    _(g, () => b.current);
    const {
      buttonProps: { role: k, ...f }
    } = A(
      {
        ...a,
        // @ts-expect-error
        onPress: N || x,
        elementType: s || c ? "a" : "button",
        isDisabled: a.disabled || a["aria-disabled"] === "true" || a["aria-disabled"] === !0
      },
      b
    ), p = v(
      o,
      "ds-btn",
      `ds-btn--${m}`,
      `ds-btn--size-${u}`,
      {
        "ds-btn--has-icon": r,
        "ds-btn--icon-only": d
      }
    ), h = {
      "--custom-border-color": e?.border ?? e?.background,
      "--custom-background-color": e?.background,
      "--custom-text-color": e?.text,
      "--custom-hover-border-color": e?.hoverBorder ?? e?.hoverBackground,
      "--custom-hover-background-color": e?.hoverBackground,
      "--custom-hover-text-color": e?.hoverText ?? e?.text
    };
    return typeof c < "u" ? /* @__PURE__ */ t(
      P,
      {
        ...f,
        ...c,
        className: p,
        style: { ...h, ...l },
        children: /* @__PURE__ */ t(
          y,
          {
            label: n,
            icons: r,
            hideLabel: d,
            tightenContent: i
          }
        )
      }
    ) : typeof s < "u" ? /* @__PURE__ */ t(
      "a",
      {
        ...f,
        ...s,
        className: p,
        style: { ...h, ...l },
        children: /* @__PURE__ */ t(
          y,
          {
            label: n,
            icons: r,
            hideLabel: d,
            tightenContent: i
          }
        )
      }
    ) : /* @__PURE__ */ t(
      "button",
      {
        ...a,
        ...f,
        role: k,
        className: p,
        "aria-labelledby": B,
        ref: b,
        style: { ...h, ...l },
        children: /* @__PURE__ */ t(
          y,
          {
            label: n,
            icons: r,
            hideLabel: d,
            tightenContent: i
          }
        )
      }
    );
  }
), y = ({
  icons: m,
  hideLabel: n,
  label: r,
  tightenContent: u
}) => /* @__PURE__ */ $(z, { children: [
  m?.map((o, s) => /* @__PURE__ */ t(
    H,
    {
      size: o.size ?? "medium",
      ...o,
      className: `ds-btn--icon-${o.placement}`
    },
    `${o.path}-${s}`
  )),
  n ? /* @__PURE__ */ t(E, { className: B, children: r }) : /* @__PURE__ */ t(
    "span",
    {
      className: v(B, {
        "--tighten-content": u
      }),
      children: r
    }
  )
] });
R.displayName = "Button";
export {
  R as B
};
//# sourceMappingURL=Button-ClBViKhc.js.map
